module.exports = __webpack_public_path__ + "assets/img/banner-index01.f504d7cb.jpg";